import React, { useContext, useEffect } from "react";

import { useHistory, useLocation } from "react-router-dom";
import { FullPageLoading } from "../../../../components/ui/Loading";
import { AuthContext } from "../../../../contexts/auth";
import { useUnauthenticatedApi } from "../../../../hooks/useApi";

interface WhatsAppLoginProps {}

const WhatsAppLogin: React.FC<WhatsAppLoginProps> = () => {
  const { search } = useLocation();
  const history = useHistory();
  const params = new URLSearchParams(search);
  const token = params.get("token");
  const propertyCode = params.get("code");
  console.log(token, "token");
  const { login } = useContext(AuthContext);
  const whatsappMagicLoginAPi = useUnauthenticatedApi(
    "AUTH_LOGIN_MAGIC_WHATSAPP"
  );

  useEffect(() => {
    whatsappMagicLoginAPi.post("/", { token: token }).then((response) => {
      login(
        response.data.user_token,
        response.data.token_expiry,
        response.data.user
      );
      history.push(`/checkin/${propertyCode}`);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [login, token, whatsappMagicLoginAPi]);

  return (
    <section>
      <FullPageLoading text="Follow your ❤️" />
    </section>
  );
};
export default WhatsAppLogin;
